export const CLICK = '[CLICAR]';
export const DRAG = '[ARRASTAR]';
export const CLICKS = '[CLIQUES]';
export const SAVE = '[SALVAR]';
export const SELECT = '[SELECIONAR]';
export const OPEN = '[ABRIR]';
export const UPDATE = '[ATUALIZAR]';
export const END = '[FINALIZAR]';
